__turbopack_context__.v({
  "authorDescription": "styles-module-scss-module__x6W97a__authorDescription",
  "authorDesignation": "styles-module-scss-module__x6W97a__authorDesignation",
  "authorImage": "styles-module-scss-module__x6W97a__authorImage",
  "authorName": "styles-module-scss-module__x6W97a__authorName",
  "authorNameAndSocialContainer": "styles-module-scss-module__x6W97a__authorNameAndSocialContainer",
  "authorTile": "styles-module-scss-module__x6W97a__authorTile",
  "authorTileHeading": "styles-module-scss-module__x6W97a__authorTileHeading",
  "authorTitle": "styles-module-scss-module__x6W97a__authorTitle",
  "blog": "styles-module-scss-module__x6W97a__blog",
  "blogBodySection": "styles-module-scss-module__x6W97a__blogBodySection",
  "blogCreateDate": "styles-module-scss-module__x6W97a__blogCreateDate",
  "blogLeadForm": "styles-module-scss-module__x6W97a__blogLeadForm",
  "blogLeadForm_mob": "styles-module-scss-module__x6W97a__blogLeadForm_mob",
  "footerSimilarBlogs": "styles-module-scss-module__x6W97a__footerSimilarBlogs",
  "mBlogLeadForm": "styles-module-scss-module__x6W97a__mBlogLeadForm",
  "rightSection": "styles-module-scss-module__x6W97a__rightSection",
  "root": "styles-module-scss-module__x6W97a__root",
  "similarBlogContainer": "styles-module-scss-module__x6W97a__similarBlogContainer",
  "socialIcon": "styles-module-scss-module__x6W97a__socialIcon",
  "socialMediaIconsContainer": "styles-module-scss-module__x6W97a__socialMediaIconsContainer",
  "tableContentWrapper": "styles-module-scss-module__x6W97a__tableContentWrapper",
  "tableHeading": "styles-module-scss-module__x6W97a__tableHeading",
  "tableListContainer": "styles-module-scss-module__x6W97a__tableListContainer",
  "tocArrow": "styles-module-scss-module__x6W97a__tocArrow",
  "tocItemActive": "styles-module-scss-module__x6W97a__tocItemActive",
  "tocList": "styles-module-scss-module__x6W97a__tocList",
  "tocListOpen": "styles-module-scss-module__x6W97a__tocListOpen",
});
